import React from 'react';
import PropTypes from 'prop-types';

export default function PdfPreview({ file }) {
  return (
    <iframe className="w-100 h-100 border-0" src={file.url} style={{ minHeight: 800 }} title="Pdf Viewer" />
  );
}

PdfPreview.propTypes = {
  file: PropTypes.shape({
    url: PropTypes.string
  })
};
